/**
 * Carousel Navigation Bar
 * Links [data-carousel-nav] elements to their carousel containers.
 * Updates counter, progress bar, and arrow disabled states on scroll/resize.
 */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initNav(nav) {
    var carouselId = nav.getAttribute('data-carousel-nav');
    var carousel = document.getElementById(carouselId);
    if (!carousel) return;

    var prevBtn = nav.querySelector('.carousel-nav__arrow--prev');
    var nextBtn = nav.querySelector('.carousel-nav__arrow--next');
    var currentEl = nav.querySelector('.carousel-nav__current');
    var totalEl = nav.querySelector('.carousel-nav__total');
    var fill = nav.querySelector('.carousel-nav__progress-fill');

    function getItems() {
      return Array.prototype.filter.call(carousel.children, function (el) {
        return el.nodeType === 1;
      });
    }

    function getGap() {
      return parseInt(getComputedStyle(carousel).gap, 10) || 0;
    }

    function update() {
      var items = getItems();
      var total = items.length;
      if (total === 0) {
        nav.classList.add('is-hidden');
        return;
      }

      var allFit = carousel.scrollWidth <= carousel.clientWidth + 2;
      if (allFit) {
        nav.classList.add('is-hidden');
        return;
      }
      nav.classList.remove('is-hidden');

      var gap = getGap();
      var itemWidth = items[0].offsetWidth;
      var step = itemWidth + gap;
      var scrollLeft = carousel.scrollLeft;
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;

      // Determine how many items are fully visible
      var visibleCount = Math.round(carousel.clientWidth / step) || 1;
      // Total "pages" the user can land on
      var totalPages = Math.max(1, total - visibleCount + 1);
      // Current page (1-indexed)
      var currentPage = Math.round(scrollLeft / step) + 1;
      currentPage = Math.max(1, Math.min(currentPage, totalPages));

      // Counter
      if (currentEl) currentEl.textContent = pad(currentPage);
      if (totalEl) totalEl.textContent = pad(totalPages);

      // Progress bar — fixed-width sliding thumb
      var thumbPct = 20;
      // Thumb position = scroll fraction * remaining track space
      var scrollFraction = maxScroll > 0 ? scrollLeft / maxScroll : 0;
      scrollFraction = Math.max(0, Math.min(1, scrollFraction));
      var leftPct = scrollFraction * (100 - thumbPct);
      if (fill) {
        fill.style.width = thumbPct + '%';
        fill.style.left = leftPct + '%';
      }

      // Arrow states
      if (prevBtn) prevBtn.disabled = scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    function scrollBy(dir) {
      var items = getItems();
      if (!items.length) return;
      var gap = getGap();
      var amount = items[0].offsetWidth + gap;
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      var targetLeft = dir > 0 && carousel.scrollLeft + amount >= maxScroll - 8
        ? maxScroll
        : carousel.scrollLeft + dir * amount;

      carousel.scrollBy({ left: targetLeft - carousel.scrollLeft, behavior: 'smooth' });
      window.setTimeout(update, 350);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollBy(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollBy(1);
      });
    }

    carousel.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    // Initial state (defer slightly for layout)
    setTimeout(update, 80);
  }

  function initAll() {
    var navs = document.querySelectorAll('[data-carousel-nav]');
    for (var i = 0; i < navs.length; i++) {
      initNav(navs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
